import { render, staticRenderFns } from "./AdminShopOrders.vue?vue&type=template&id=44fa90a0&scoped=true&"
import script from "./AdminShopOrders.vue?vue&type=script&lang=js&"
export * from "./AdminShopOrders.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopOrders.vue?vue&type=style&index=0&id=44fa90a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa90a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fa90a0')) {
      api.createRecord('44fa90a0', component.options)
    } else {
      api.reload('44fa90a0', component.options)
    }
    module.hot.accept("./AdminShopOrders.vue?vue&type=template&id=44fa90a0&scoped=true&", function () {
      api.rerender('44fa90a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminShopOrders.vue"
export default component.exports